<app-legal-page titleKey="LEGAL.TERMS.TITLE" [introKey]="introKey" [sections]="sections"></app-legal-page>